import { makeOdataOrderBy } from './makeOrderBy';
import { makeOdataFilter } from './makeFilter';
/** Converts structured query object to an odata query string. */
export const formatOdataQuery = (query = {}, uniqueIdentifier, isSingletonQuery) => {
    var _a, _b;
    if (isSingletonQuery) {
        const idData = (_b = (_a = query.filter) === null || _a === void 0 ? void 0 : _a[uniqueIdentifier]) === null || _b === void 0 ? void 0 : _b.data;
        if (!idData) {
            return '';
        }
        return `/${idData}`;
    }
    const qsOrderBy = makeOdataOrderBy(query === null || query === void 0 ? void 0 : query.orderBy);
    const qsFilter = makeOdataFilter(query === null || query === void 0 ? void 0 : query.filter);
    const qsSkip = query.skip && `$skip=${query.skip}`;
    const qsTop = query.top && `$top=${query.top}`;
    const qsExpand = query.expand && `$expand=${query.expand.join(',')}`;
    const qsSelect = query.select && `$select=${query.select.join(',')}`;
    const qsOutput = [qsSelect, qsOrderBy, qsFilter, qsSkip, qsTop, qsExpand]
        .filter(i => !!i)
        .join('&');
    return `?${qsOutput}`;
};
/** Helper enum in case you don't want to google what those codes mean. */
export var ODataOperators;
(function (ODataOperators) {
    ODataOperators["lessThan"] = "lt";
    ODataOperators["greaterThan"] = "gt";
    ODataOperators["equalTo"] = "eq";
    ODataOperators["greaterThanOrEqualTo"] = "ge";
    ODataOperators["lessThanOrEqualTo"] = "le";
    ODataOperators["notEqualTo"] = "ne";
})(ODataOperators || (ODataOperators = {}));
